export enum Paths {
  AUTH = '/auth',
  QUESTIONNAIRE = '/questionnaire',
  ANSWERS = '/answers',
  ANSWER = '/answer',
  LETTERS = '/letters',
  DASHBOARD = '/dashboard',
  CHANGELOG = '/changelog',
  ID = ':id',
  EDIT = '/edit',
  NEW_COMPONENTS = '/new-components',
  NOT_FOUND = '/notfound',
}

export enum AuthPaths {
  LOGIN = 'login',
  TEST_LOGIN = 'test-login',
  REDIRECT = 'redirect',
  REFRESH = 'refresh',
  LOGOUT = 'logout',
  LOGOUT_REDIRECT = 'logout-redirect',
}

export enum AnswerPaths {
  ID = ':id',
  ANSWER = 'answer',
  ANSWERS = 'answers',
  EDIT = 'edit',
  NOT_FOUND = 'notfound',
}

export enum QuestionnairePaths {
  QUESTIONNAIRE = 'questionnaire',
  EDIT = 'edit',
  ID = ':id',
  NOT_FOUND = 'notfound',
}

export enum CommonPaths {
  NOT_FOUND = 'notfound',
}
